import {
  DocumentTemplateColumn,
  DocumentTemplateColumnInterface,
} from './documentTemplateColumn';

export interface DocumentTemplateRowInterface {
  id?: string;
  order: number;
  _destroy?: boolean;
  columns?: DocumentTemplateColumnInterface[];
  document_template_columns_attributes?: DocumentTemplateColumnInterface[];
}

export class DocumentTemplateRow implements DocumentTemplateRowInterface {
  id: string;
  order: number;
  columns: DocumentTemplateColumn[];
  _destroy?: boolean;

  constructor(data: Partial<DocumentTemplateRowInterface>) {
    this.id = data.id!;
    this.order = data.order!;
    this._destroy = data._destroy || false;
    this.columns =
      data.columns?.map(columnData => new DocumentTemplateColumn(columnData)) ||
      [];
  }

  toJson(): DocumentTemplateRowInterface {
    const idIsNumeric = /^\d+$/.test(this.id);
    return {
      id: idIsNumeric ? this.id : undefined,
      order: this.order,
      _destroy: this._destroy,
      document_template_columns_attributes: this.columns.map(column =>
        column.toJson(),
      ),
    };
  }
}
